import { render, staticRenderFns } from "./avatarComp.vue?vue&type=template&id=41f1cfe4"
import script from "./avatarComp.vue?vue&type=script&lang=js"
export * from "./avatarComp.vue?vue&type=script&lang=js"
import style0 from "./avatarComp.vue?vue&type=style&index=0&id=41f1cfe4&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports